import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import MillionaireGame from "./MillionaireGame";


const MillionaireGameWrapper = () => {
  const { assignmentId } = useParams();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const assignmentRef = doc(db, "assignments", assignmentId);
        const assignmentSnap = await getDoc(assignmentRef);

        if (assignmentSnap.exists()) {
          const assignmentData = assignmentSnap.data();
          const questionIds = assignmentData.questions || [];

          const questionPromises = questionIds.map((qid) =>
            getDoc(doc(db, "questions", qid))
          );

          const questionDocs = await Promise.all(questionPromises);

          const formattedQuestions = questionDocs
            .map((docSnap) => {
              const data = docSnap.data();
              if (!data) return null;

              return {
                id: docSnap.id,
                questionText: data.questionText || "No text",
                options: data.options || [], // must be an array of 4 options
                answers: data.answers || [data.answer], // either "answers" array or single "answer"
              };
            })
            .filter((q) => q && q.options.length === 4); // Only include valid ones

          setQuestions(formattedQuestions);
        }
      } catch (error) {
        console.error("Error fetching Millionaire game questions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, [assignmentId]);

  if (loading) {
    return <p style={{ padding: "2rem" }}>🎮 Loading Millionaire game...</p>;
  }

  return <MillionaireGame questions={questions} />;
};

export default MillionaireGameWrapper;
